import { render, staticRenderFns } from "./ColumnUsers.vue?vue&type=template&id=4b76087c&scoped=true"
import script from "./ColumnUsers.vue?vue&type=script&lang=ts"
export * from "./ColumnUsers.vue?vue&type=script&lang=ts"
import style0 from "./ColumnUsers.vue?vue&type=style&index=0&id=4b76087c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b76087c",
  null
  
)

export default component.exports